import { Profile } from '../data/Profile';
import { fetchWithTimeout } from './fetchWithTimeout';

type LoginRequestData = {
    account: string;
    password: string;
};

type LoginResponseData = {
    statusCode: number;
    message: string;
    access_token?: string;
};

function login(data: LoginRequestData) {
    return fetchWithTimeout('auth/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: LoginResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type LineLoginRequestData = {
    access_token: string | null;
    id_token: string | null;
};

type LineLoginResponseData = {
    statusCode: number;
    message: string;
    access_token?: string;
};

function lineLogin(data: LineLoginRequestData) {
    return fetchWithTimeout('auth/lineLogin', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
    })
        .then((res) => res.json())
        .then((data: LineLoginResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

type ProfileResponseData = { statusCode?: number; message?: string } & Profile;

function profile(token?: string) {
    return fetchWithTimeout(
        'auth/profile',
        {
            method: 'GET',
        },
        10000,
        token,
    )
        .then((res) => res.json())
        .then((data: ProfileResponseData) => data)
        .catch((error) => {
            throw error;
        })
        .finally(() => {});
}

export default { login, lineLogin, profile };
